import {AxiosResponse} from 'axios'

import {
  RemoveDormantEndpointsParams,
  EndpointMetaDataType,
  EndpointsSearchRequest,
  EndpointsSearchResponse,
  RemoveDormantEndpointsResponse,
} from 'interfaces'
import {unwrapAPIError} from 'utils'
import {getEndpointBaseUrl, getFlightdeckBaseUrl, requestHandler} from '../HTTP'
import {EndPoints, HttpMethods} from '../HTTP/HTTP.types'

const endpointBaseUrl = getEndpointBaseUrl()
const flightdeckBaseUrl = getFlightdeckBaseUrl()

const getEndpointMetaData = async (): Promise<
  AxiosResponse<EndpointMetaDataType>
> => {
  try {
    return await requestHandler({
      method: HttpMethods.GET,
      url: `${endpointBaseUrl}${EndPoints.GetEndpointMetadata}?aggregation=endpoint_details`,
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const getEndpointsSearch = async (
  params: EndpointsSearchRequest,
): Promise<AxiosResponse<EndpointsSearchResponse>> => {
  try {
    return await requestHandler<EndpointsSearchResponse>({
      method: HttpMethods.GET,
      // Override axios baseUrl
      url: `${flightdeckBaseUrl}${EndPoints.EndpointsSearch}`,
      options: {
        params,
      },
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const removeDormantEndpoints = async (
  params: RemoveDormantEndpointsParams,
): Promise<RemoveDormantEndpointsResponse> => {
  try {
    const {data: response} =
      await requestHandler<RemoveDormantEndpointsResponse>({
        method: HttpMethods.POST,
        url: `${flightdeckBaseUrl}${EndPoints.RemoveDormantEndpoints}`,
        data: {
          data: {
            ...params,
          },
        },
      })
    return response
  } catch (error) {
    throw unwrapAPIError(error)
  }
}

export const EndpointsService = {
  getEndpointMetaData,
  getEndpointsSearch,
  removeDormantEndpoints,
}
